var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18812 14H13.8176C14.7007 14 15.2693 13.0384 14.8701 12.2266L8.55532 0.674309C8.1197 -0.22477 6.87381 -0.22477 6.43831 0.674309L0.123561 12.2266C-0.26355 13.0384 0.305019 14 1.18812 14ZM8.49495 11.3149C8.49495 11.9143 8.07155 12.3764 7.46669 12.3764C6.86183 12.3764 6.43843 11.9143 6.43843 11.3149V11.2899C6.43843 10.6904 6.86183 10.2283 7.46669 10.2283C8.07155 10.2283 8.49495 10.6904 8.49495 11.2899V11.3149ZM6.9101 3.5093H8.09575C8.42225 3.5093 8.61593 3.79654 8.57963 4.15872L8.05933 8.85456C8.02304 9.19176 7.80529 9.40407 7.50286 9.40407C7.20043 9.40407 6.98268 9.19176 6.94639 8.85456L6.42609 4.15872C6.38992 3.79654 6.58359 3.5093 6.9101 3.5093Z",
    fill: "#F88800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.fddf5ce7.svg";
export { ForwardRef as ReactComponent };